import React, { useEffect } from "react";
import NavigateBack from "../../components/navigateBack";
import { Grid } from "@material-ui/core";
import { Container } from "react-bootstrap";

import { ReactComponent as PDFIcon } from "../../img/icons/icon_pdf.svg";

import createPersistedState from "use-persisted-state";
import { useTranslation } from "react-i18next";
const useTokenState = createPersistedState("token");
const usePIDState = createPersistedState("pid");

const Diet = () => {
  const [isFetchingDiet, setIsFetchingDiet] = React.useState(true);
  const [dietData, setDietData] = React.useState(null);

  const [noData, setNoData] = React.useState(false);

  const { t } = useTranslation();
  const [token, _] = useTokenState();
  const [pid, __] = usePIDState();

  const fetchDietData = async () => {
    const url = `/api/v1/users/diet-chart/${pid}?sessions=true`;
    setIsFetchingDiet(true);
    try {
      const response = await fetch(url, {
        method: "GET",
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      });
      if (!response.ok) {
        throw new Error("Network response was not ok");
      }
      const data = await response.json();
      data?.sessions && setDietData(data.sessions);
      if (!data?.sessions) {
        setNoData(true);
      }
    } catch (error) {
      console.error("Error fetching diet data:", error);
    } finally {
      setIsFetchingDiet(false);
    }
  };

  useEffect(() => {
    fetchDietData();
  }, [token, pid]);

  return (
    <>
      <NavigateBack title={"Diet"} />
      <div style={{ marginTop: "78px" }}>
        <Grid container spacing={0}>
          <Grid item xs={6}>
            <Container maxWidth="sm" disableGutters></Container>
          </Grid>
        </Grid>
      </div>
      <div className="body_padding ">
        <div className="inner_body">
          <span></span>
          {isFetchingDiet && (
            <div
              style={{
                margin: "auto",
                display: "flex",
                justifyContent: "center",
              }}
              id="loader"
            ></div>
          )}
          {/* {error !== "" && <span className="txt_msg">{error}</span>}
          {noRecentReports && <span>{t("testReports.noRectentReports")}</span>}
          <div style={{ marginTop: "1em" }}></div>
          <ul className=" list_pdf">{recentReportListing}</ul>
          <div style={{ marginTop: "1em" }}></div> */}
          {dietData?.["1st Session"] && (
            <div>
              <div
                style={{ color: "var(--darkbluecolortwo)" }}
                className="diet_title fw-bold mb-1"
              >
                1st Session
              </div>

              {dietData?.["1st Session"]?.map((item, index) => (
                <div
                  key={index}
                  className="diet_data d-flex justify-content-start align-items-center p-2 border border-1 border-medium mb-2"
                >
                  <PDFIcon />
                  <a
                    className="ms-2"
                    href={item.signedUrl}
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    {item.name}
                  </a>
                </div>
              ))}
              <div className="divider" />
            </div>
          )}

          {dietData?.["2nd Session"] && (
            <div>
              <div
                style={{ color: "var(--darkbluecolortwo)" }}
                className="diet_title fw-bold mb-1"
              >
                2nd Session
              </div>

              {dietData?.["2nd Session"]?.map((item, index) => (
                <div
                  key={index}
                  className="diet_data d-flex justify-content-start align-items-center p-2 border border-1 border-medium mb-2"
                >
                  <PDFIcon />
                  <a
                    className="ms-2"
                    href={item.signedUrl}
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    {item.name}
                  </a>
                </div>
              ))}
            </div>
          )}
          {dietData?.["3rd Session"] && (
            <div>
              <div
                style={{ color: "var(--darkbluecolortwo)" }}
                className="diet_title fw-bold mb-1"
              >
                3rd Session
              </div>

              {dietData?.["3rd Session"]?.map((item, index) => (
                <div
                  key={index}
                  className="diet_data d-flex justify-content-start align-items-center p-2 border border-1 border-medium mb-2"
                >
                  <PDFIcon />
                  <a
                    className="ms-2"
                    href={item.signedUrl}
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    {item.name}
                  </a>
                </div>
              ))}
            </div>
          )}
          {noData && (
            <div
              style={{
                margin: "auto",
                display: "flex",
                justifyContent: "center",
              }}
            >
              <span className="txt_msg">No Diet Plan Available</span>
            </div>
          )}
        </div>
      </div>
    </>
  );
};

export default Diet;
